import {
  LOGIN_REQUEST,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  REGISTER_USER_REQUEST,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAIL,
  LOAD_USER_REQUEST,
  LOAD_USER_SUCCESS,
  LOAD_USER_FAIL,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAIL,
  UPDATE_PROFILE_RESET,
  UPDATE_JOBSTATUS_REQUEST,
  UPDATE_JOBSTATUS_SUCCESS,
  UPDATE_JOBSTATUS_FAIL,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_RESET,
  UPDATE_PASSWORD_FAIL,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  ALL_USERS_REQUEST,
  ALL_USERS_SUCCESS,
  ALL_USERS_FAIL,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  DELETE_USER_RESET,
  DELETE_JOB_REQUEST,
  DELETE_JOB_SUCCESS,
  DELETE_JOB_FAIL,
  DELETE_JOB_RESET,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  UPDATE_USER_RESET,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_FAIL,
  CV_UPLOADED_REQUEST,
  CV_UPLOADED_SUCCESS,
  CV_UPLOADED_FAIL,
  CLEAR_ERRORS,
  CREATE_JOB_REQUEST,
  CREATE_JOB_SUCCESS,
  CREATE_JOB_FAIL,
  JOBS_DETAILS_SUCCESS,
  JOBS_DETAILS_REQUEST,
  JOBS_DETAILS_FAIL,
  SINGLE_JOB_DETAILS_REQUEST,
  SINGLE_JOB_DETAILS_SUCCESS,
  SINGLE_JOB_DETAILS_FAIL,
  ADD_CANDIDATE_REQUEST,
  ADD_CANDIDATE_SUCCESS,
  ADD_CANDIDATE_FAIL,
  GET_ALL_CANDIDATES_OF_JOB_REQUEST,
  GET_ALL_CANDIDATES_OF_JOB_SUCCESS,
  GET_ALL_CANDIDATES_OF_JOB_FAIL,
  GET_ALL_CUSTOMER_OF_CORP_REQUEST,
  GET_ALL_CUSTOMER_OF_CORP_SUCCESS,
  GET_ALL_CUSTOMER_OF_CORP_FAIL,
  TOGGLE_IS_ON,
  SET_LOGO,
  NOTIFICATIONS_SUCCESS,
  NOTIFICATIONS_REQUEST,
  NOTIFICATIONS_FAIL,
  TEAM_MEMBERS_REQUEST,
  TEAM_MEMBERS_SUCCESS,
  TEAM_MEMBERS_FAIL
} from "../constants/userConstants";


const initialLogo = {
  logo: "/images/logo.png",
}

export const logoReducer = (state = initialLogo, action) => {
  switch (action.type) {
    case SET_LOGO:
      return {
        ...state,
        logo: action.payload,
      }
    default:
      return state;
  }
};

const initialLanguageState = {
  isArabic: false,
};

export const languageReducer = (state = initialLanguageState, action) => {
  switch (action.type) {
    case TOGGLE_IS_ON:
      return {
        ...state,
        isArabic: !state.isArabic,
      };
    default:
      return state;
  }
};

const initial = {
  user: {},
};

export const userReducer = (state = initial, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
    case REGISTER_USER_REQUEST:
    case LOAD_USER_REQUEST:
      return {
        ...state,
        loading: true,
        isAuthenticated: false,
      };
    case LOGIN_SUCCESS:
    case REGISTER_USER_SUCCESS:
    case LOAD_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload,
      };

    case LOGOUT_SUCCESS:
      return {
        loading: false,
        user: null,
        isAuthenticated: false,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: null,
        error: action.payload,
      };

    case REGISTER_USER_FAIL:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: null,
        error: action.payload,
      };

    case LOAD_USER_FAIL:
      //throw new Error(action.payload);
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: null,
        error: action.payload,
      };

    case LOGOUT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const profileReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_PROFILE_REQUEST:
    case UPDATE_PASSWORD_REQUEST:
    case UPDATE_JOBSTATUS_REQUEST:
    case UPDATE_USER_REQUEST:
    case DELETE_USER_REQUEST:
    case DELETE_JOB_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_PROFILE_SUCCESS:
    case UPDATE_JOBSTATUS_SUCCESS:
    case UPDATE_PASSWORD_SUCCESS:
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        isUpdated: action.payload,
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        isDeleted: action.payload.success,
        message: action.payload.message,
      };

    case DELETE_JOB_SUCCESS:
      return {
        ...state,
        loading: false,
        isDeleted: action.payload,
      };

    case UPDATE_PROFILE_FAIL:
    case UPDATE_JOBSTATUS_FAIL:
    case UPDATE_PASSWORD_FAIL:
    case UPDATE_USER_FAIL:
    case DELETE_USER_FAIL:
    case DELETE_JOB_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PROFILE_RESET:
    case UPDATE_PASSWORD_RESET:
    case UPDATE_USER_RESET:
      return {
        ...state,
        isUpdated: false,
      };

    case DELETE_USER_RESET:
      return {
        ...state,
        isDeleted: false,
      };

    case DELETE_JOB_RESET:
      return {
        ...state,
        isDeleted: false,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const forgotPasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };

    case FORGOT_PASSWORD_FAIL:
    case RESET_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const allUsersReducer = (state = { users: [] }, action) => {
  switch (action.type) {
    case ALL_USERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
      };

    case ALL_USERS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const userDetailsReducer = (state = { user: {} }, action) => {
  switch (action.type) {
    case USER_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };

    case USER_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const cvsUploadedReducer = (state = { user: {} }, action) => {
  switch (action.type) {
    case CV_UPLOADED_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CV_UPLOADED_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };

    case CV_UPLOADED_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

const initialForJob = {
  user: {},
  isArabic: false,
};

export const createJobReducer = (state = initialForJob, action) => {
  switch (action.type) {
    case JOBS_DETAILS_REQUEST:
    case SINGLE_JOB_DETAILS_REQUEST:
    case CREATE_JOB_REQUEST:

      return {
        ...state,
        loading: true,

      };
    case JOBS_DETAILS_SUCCESS:
    case CREATE_JOB_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.getAllJobs,
        data: { ...action.payload },
      };
    case SINGLE_JOB_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        singleJob: action.payload,
      };
    case JOBS_DETAILS_FAIL:
    case SINGLE_JOB_DETAILS_FAIL:
    case CREATE_JOB_FAIL: {
      // throw new Error(action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};



const initialState = { addCandidate: {}, loading: false, error: null };

export const addCandidateReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CANDIDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_CANDIDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
        error: null, // Reset the error to null on success
      };
    case ADD_CANDIDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

const initialStateCandidate = {
  user: [],      // Initialize as an array to hold candidate data
  loading: false,
  error: null
};

export const allCandidatesOfJobReducer = (state = initialStateCandidate, action) => {
  switch (action.type) {
    case GET_ALL_CANDIDATES_OF_JOB_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_ALL_CANDIDATES_OF_JOB_SUCCESS:
      // Assuming action.payload has a property 'candidatemapping' which is an array
      return {
        ...state,
        loading: false,
        user: action.payload.candidatemapping || [], // Correctly handle the payload
      };
    case GET_ALL_CANDIDATES_OF_JOB_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};


export const allCustomersOfCorpReducer = (state = { user: [] }, action) => {
  switch (action.type) {
    case GET_ALL_CUSTOMER_OF_CORP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_CUSTOMER_OF_CORP_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.customers,
        totalCustomers: action.payload.totalCustomers,
      };
    case GET_ALL_CUSTOMER_OF_CORP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const notificationsReducer = (state = { data: [] }, action) => {
  switch (action.type) {
    case NOTIFICATIONS_REQUEST:
      return { loading: true, data: [] };
    case NOTIFICATIONS_SUCCESS:
      return { loading: false, data: action.payload };
    case NOTIFICATIONS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const getTeamMembersReducer = (state = { data: [] }, action) => {
  switch (action.type) {
    case TEAM_MEMBERS_REQUEST:
      return { loading: true, data: [] };
    case TEAM_MEMBERS_SUCCESS:
      return { loading: false, data: action.payload };
    case TEAM_MEMBERS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

